import { render, staticRenderFns } from "./PureSpecsForm.vue?vue&type=template&id=004d046e&scoped=true"
import script from "./PureSpecsForm.vue?vue&type=script&lang=js"
export * from "./PureSpecsForm.vue?vue&type=script&lang=js"
import style0 from "./PureSpecsForm.vue?vue&type=style&index=0&id=004d046e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d046e",
  null
  
)

export default component.exports